<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal"  v-click-outside="closeModal">
      <!--Название-->
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 3"
             style="cursor: pointer;"
             @click="closeModal()">
          <md-icon>close</md-icon>
        </div>
        <div class="uk-modal-title">
          <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small">
            <div>
              Новый тип функции
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
          <div>
            <div class="uk-margin-xsmall">
              Название типа функции
            </div>
            <div>
              <input type="text" class="uk-input">
            </div>
          </div>
          <div>
            <div class="uk-margin-xsmall">Усилители:</div>
            Тут будет v-select с мульти выбором усилителей
<!--            <v-select :class="'uk-margin-small-top tm-v-select ' + (functionErrors['types'] ? ' uk-form-danger ' : '')"-->
<!--                      v-model="newFunction.capacities"-->
<!--                      :options="capacities"-->
<!--                      multiple-->
<!--                      :disabled="newFunction.id ? true: false"-->
<!--                      aria-label="Select">-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: "ModalFunctionCategoryDialog",
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

  },
  async created() {
  }
}
</script>